module.exports = __webpack_public_path__ + "static/a1-769bdf51d206df91479dc642fb39300d.png";